import React, { useRef, useState } from 'react';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { Flex, Image, message, Upload } from 'antd';
import { handleFileUploadChange, handleImageRemove as handleFileRemove } from '@utils/file-uploader-utils';
import { strings } from '@constants/strings';
import { Button, Skeleton, TextWithIcon } from '@common-web';
import styles from './index.module.scss';
import { FaImages } from 'react-icons/fa';
import { MAX_IMAGE_SIZE } from '@constants/generic-constants';

const FileUpload = ({
  uploadMultiple = false,
  onChange = () => { },
  attachmentType = 'documents',
  associationKey = 'file',
  value = [],
  conditionToShowUploadBtn = true,
  uploadButtonWithList = false,
  showCustomRender = false,
  customItemRender = () => { },
  uploadBtnText = 'Add File',
  showDescription = false,
  descriptors = [],
  uploadMultipleStyles = false,
  loading = false,
  setLoading = () => { },
  disabled = false,
  maxCount = undefined,
  formats = '.pdf, .doc, .docx, .png, .jpg, .jpeg',
}) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);

  const uploadRef = useRef(null);

  const handleButtonClick = (e) => {
    uploadRef.current?.upload?.uploader?.onClick(e);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  return (
    <>
      <Upload
        disabled={disabled}
        name={'file'}
        accept={formats}
        listType={'text'}
        multiple={uploadMultiple}
        onPreview={handlePreview}
        onChange={({ file, fileList }) => {
          const allowedFormats = formats ? formats.split(',').map((format) => format.trim().toLowerCase()) : [];
          const fileName = file?.name?.toLowerCase();
          const isFormatValid = allowedFormats.some((format) => fileName.endsWith(format));
          if (!isFormatValid) {
            message.error(`${strings?.file} ${file?.name} has invalid format. Allowed formats: ${formats}`);
          } else if (file?.size > MAX_IMAGE_SIZE) {
            message.error(`${strings?.file} ${file?.name} ${strings?.file_size_too_large_5mb}`);
          } else {
            const index = value?.findIndex((e) => e?.uid === file?.uid);
            if (index > -1) {
            } else {
              setCurrentFile(file);
              handleFileUploadChange({
                file,
                fileList,
                attachmentType,
                associationKey,
                setter: onChange,
                loadingSetter: setLoading,
              });
            }
          }
        }}
        beforeUpload={() => {
          return false;
        }}
        onRemove={(file) => {
          handleFileRemove({ file, files: value, setter: onChange });
        }}
        openFileDialogOnClick={false}
        ref={uploadRef}
        fileList={value}
        {...(showCustomRender ? { itemRender: customItemRender } : {})}
        maxCount={maxCount}
      >
        {conditionToShowUploadBtn && !loading ? (
          uploadButtonWithList ? (
            <Flex align="center" gap={50}>
              {uploadMultiple || uploadMultipleStyles ? (
                <>
                  <Flex vertical gap={8}>
                    <Button
                      onClick={handleButtonClick}
                      text={uploadBtnText}
                      type={'primary'}
                      shape={'round'}
                      icon={'FaImages'}
                    />
                  </Flex>
                  {showDescription && (
                    <Flex gap={6} vertical>
                      {descriptors.map((description) => (
                        <TextWithIcon icon="FaCheck" iconColor="#00A651" text={description} />
                      ))}
                    </Flex>
                  )}
                </>
              ) : (
                <Flex onClick={handleButtonClick} align="center" gap={4} className={styles.uploadImgBtn}>
                  <FaImages size={20} color="var(--ant-color-primary)" />
                  <span className="fw-600">{uploadBtnText}</span>
                </Flex>
              )}
            </Flex>
          ) : (
            <button
              style={{
                border: 0,
                background: 'none',
              }}
              type="button"
            >
              {loading ? <LoadingOutlined /> : <PlusOutlined />}
              <div
                style={{
                  marginTop: 8,
                }}
              >
                {loading ? strings.uploading : strings.upload}
              </div>
            </button>
          )
        ) : (
          loading && (
            <Skeleton
              width={currentFile?.type?.includes('image/') || !uploadMultipleStyles ? 88 : '100%'}
              height={88}
            />
          )
        )}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: 'none',
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(null),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};

export default FileUpload;
